export { default } from './SalesCoachModal';
